import React from 'react';
import {
  getContent,
  formatDate,
  getVerificationInterval,
  getLastValues,
  getDownloadActContent,
} from './utils';
import styles from './MeterInfo.module.scss';
import TarifView from '../TarifView/TarifView';
import VisibilityOwnerView from '../VisibilityOwnerView/VisibilityOwnerView';

export const blocks = [
  {
    title: 'Тип',
    renderContent: ({ meter }) => getContent(meter?.type?.name),
  },

  {
    title: 'Заводской номер',
    renderContent: ({ meter }) => getContent(meter?.serialNumber),
  },

  {
    title: 'Модель',
    renderContent: ({ meter }) => getContent(meter?.model),
  },

  {
    title: 'Марка',
    renderContent: ({ meter }) => getContent(meter?.mark),
  },

  {
    title: 'Номер пломбы',
    renderContent: ({ meter }) => getContent(meter?.sealNumber),
  },

  {
    title: 'Статус',
    renderContent: ({ meter }) => getContent(meter?.statusName),
  },

  {
    title: 'Тариф',
    renderContent: ({ meter }) => <TarifView tarifId={meter?.tariffCount} />,
    contentComponent: 'div',
  },

  {
    title: 'Дата установки',
    renderContent: ({ meter }) => formatDate(meter?.installDate),
  },

  {
    title: 'Дата ввода в эксплуатацию',
    renderContent: ({ meter }) => formatDate(meter?.commissioningDate),
  },

  {
    title: 'Дата поверки',
    renderContent: ({ meter }) => formatDate(meter?.verificationDate),
  },

  {
    title: 'Интервал поверки',
    renderContent: ({ meter }) =>
      getVerificationInterval(meter?.verificationInterval),
  },

  {
    title: 'Планируемая поверка',
    renderContent: ({ meter }) => formatDate(meter?.nextVerificationDate),
  },

  {
    title: 'Место установки',
    renderContent: ({ meter }) => getContent(meter?.location?.name),
  },

  {
    title: 'Видимость собственнику',
    renderContent: ({ meter }) =>
      meter?.showToClient ? (
        <VisibilityOwnerView visible={meter?.showToClient} />
      ) : (
        getContent()
      ),
  },

  {
    title: 'Показания',
    renderContent: ({ meter }) =>
      getLastValues(meter?.lastValues, meter?.type?.unit?.name),
    contentComponent: 'div',
    contentClasses: styles.contentWrap,
  },

  {
    title: 'Дата показаний',
    renderContent: ({ meter }) =>
      getLastValues(meter?.lastValues, meter?.type?.unit?.name, true),
    contentComponent: 'div',
    contentClasses: styles.contentWrap,
  },

  {
    title: 'Акт ввода в эксплуатацию',
    renderContent: ({ meter, url, loading }) =>
      getDownloadActContent({ meter, url, loading }),
  },
];
